function fn_comp_visual() {
    var $fn = $(".comp_visual"),
        $slider = $fn.find("[data-visual-slider]"),
        $slider_caption = $fn.find("[data-visual-caption]"),
        $data_slider_autoplay = $slider.data("visual-slider");

    if ($slider.children().length > 1) {
        $slider.slick({
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: $data_slider_autoplay,
            arrows: false,
            pauseOnHover: false,
            asNavFor: $slider_caption,
            dots: true
        });
        $slider.on('afterChange', function(){
            $(this).find(".slick-active").find("img").addClass("lazyload");
        });
    }
    if ($slider_caption.children().length > 1) {
        $slider_caption.slick({
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            arrows: false,
            dots: false,
            asNavFor: $slider,
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        adaptiveHeight: false
                    }
                }
            ]
        });
        $slider_caption.find(".elm_content").each(function (index) {
            var $this = $(this);
            var $points = [[0.0, 0.0], [98.8, 1.4], [100, 98.2], [1.8, 96.1], [0.0, 0.0]];;
            $this.clipPath($points, {
                isPercentage: true,
                svgDefId: "visualclip"+index
            })
        })
    }
}